(function () {
  "use strict";

  function fitText(el, minSize, shrinkBy) {
    if (!el) return;
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || el.offsetParent === null) return;

    if (!el.dataset.esOriginalFontSize) {
      var computed = getComputedStyle(el).fontSize;
      el.dataset.esOriginalFontSize = parseFloat(computed) || 16;
    }
    var size = parseFloat(el.dataset.esOriginalFontSize) - (shrinkBy || 0);
    if (size < minSize) size = minSize;
    el.style.setProperty("font-size", size + "px", "important");
    el.style.setProperty("white-space", "nowrap", "important");

    var guard = 0;
    while (el.scrollWidth > el.clientWidth + 1 && size > minSize && guard < 40) {
      size -= 0.5;
      el.style.setProperty("font-size", size + "px", "important");
      guard++;
    }
  }

  function findCrossedPrice(card) {
    var byClass = card.querySelector(".es-o-cp");
    if (byClass) return byClass;
    var all = card.querySelectorAll("p, span, div, del, s, strike");
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length > 0) continue;
      var deco = getComputedStyle(el).textDecorationLine || getComputedStyle(el).textDecoration;
      if (deco && deco.indexOf("line-through") !== -1) {
        return el;
      }
    }
    return null;
  }

  function reserveSpaceForCrossedPrice(card) {
    var priceEl = findCrossedPrice(card);
    var nameEl = card.querySelector(".mb-1");
    if (!priceEl || !nameEl) {
      if (nameEl) nameEl.style.removeProperty("padding-right");
      return;
    }

    var priceRect = priceEl.getBoundingClientRect();
    var nameRect = nameEl.getBoundingClientRect();

    var sameLine = priceRect.top < nameRect.bottom && priceRect.bottom > nameRect.top;
    if (!sameLine || priceRect.width === 0) {
      nameEl.style.removeProperty("padding-right");
      return;
    }

    nameEl.style.setProperty("box-sizing", "border-box", "important");
    nameEl.style.removeProperty("padding-right");
    nameRect = nameEl.getBoundingClientRect();
    var reserve = nameRect.right - priceRect.left + 14;
    if (reserve > 0) {
      nameEl.style.setProperty("padding-right", reserve + "px", "important");
    }
  }

  function unstickPrices() {
    document.querySelectorAll("#easysell .es-qo-container").forEach(function (card) {
      reserveSpaceForCrossedPrice(card);
    });
  }

  function fitAll() {
    if (window.innerWidth > 600) return;
    unstickPrices();
    var SHRINK = 2;
    document.querySelectorAll("#easysell .es-qo-container .mb-1").forEach(function (el) {
      fitText(el, 10, SHRINK);
    });
    document.querySelectorAll("#easysell .es-qo-container .es-offer-badge").forEach(function (el) {
      fitText(el, 9, SHRINK);
    });
    document.querySelectorAll("#easysell .es-qo-container .es-o-p").forEach(function (el) {
      fitText(el, 12, SHRINK);
    });
  }

  function runFit() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fitAll();
        requestAnimationFrame(fitAll);
      });
    });
  }

  var debounceTimer = null;
  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runFit, 120);
  }

  document.addEventListener("DOMContentLoaded", schedule);
  window.addEventListener("load", schedule);
  window.addEventListener("resize", schedule);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule);
    document.fonts.ready.then(function () {
      setTimeout(schedule, 300);
      setTimeout(schedule, 800);
    });
  }

  var pollCount = 0;
  var pollInterval = setInterval(function () {
    pollCount++;
    fitAll();
    if (pollCount > 25) {
      clearInterval(pollInterval);
    }
  }, 300);

  function watch(target) {
    if (!target || !window.MutationObserver) return;
    var obs = new MutationObserver(schedule);
    obs.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"]
    });
  }

  document.addEventListener(
    "click",
    function (e) {
      if (e.target && e.target.closest && e.target.closest("#easysell")) {
        schedule();
        setTimeout(schedule, 250);
        setTimeout(schedule, 600);
      }
    },
    true
  );

  var existing = document.getElementById("easysell");
  if (existing) {
    watch(existing);
    schedule();
  } else {
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      var el = document.getElementById("easysell");
      if (el) {
        clearInterval(interval);
        watch(el);
        schedule();
      } else if (tries > 40) {
        clearInterval(interval);
      }
    }, 250);
  }
})();
